// extracted by mini-css-extract-plugin
export default {"breadcrumbFirst":"Breadcrumb_breadcrumbFirst__iNB5T"};